import type { StaticLandingPage } from '../../../content';
import heroImage from './assets/hero-corporate-training.jpg';
import methodologyWorkshopImage from './assets/methodology-workshop.jpg';
import methodologyTeamImage from './assets/methodology-team.jpg';
import logoAcciona from './assets/clients/acciona.png';
import logoAirbus from './assets/clients/airbus.png';
import logoCaixaBank from './assets/clients/caixabank.png';
import logoCupra from './assets/clients/cupra.png';
import logoEndesa from './assets/clients/endesa.png';
import logoFerrovial from './assets/clients/ferrovial.png';
import logoGestamp from './assets/clients/gestamp.png';
import logoIberdrola from './assets/clients/iberdrola.png';
import logoNaturgy from './assets/clients/naturgy.png';
import logoRepsol from './assets/clients/repsol.png';
import logoSacyr from './assets/clients/sacyr.png';
import logoSiemens from './assets/clients/siemens.png';

export const academyEsPage = {
  slug: 'aca-es-incompany',
  archetype: 'corporate-b2b',
  body: [
    {
      _uid: 'academy-es-corporate-nav',
      component: 'corporate_sticky_nav_section',
      label: 'Academy España',
      cta_label: 'Solicitar información',
      links: [
        { href: '#ventajas', label: 'Ventajas' },
        { href: '#areas', label: 'Áreas' },
        { href: '#proceso', label: 'Proceso' },
        { href: '#metodologia', label: 'Metodología' },
        { href: '#faq', label: 'FAQ' },
        { href: '#contacto', label: 'Contacto' },
      ],
    },
    {
      _uid: 'academy-es-corporate-hero',
      component: 'corporate_hero_section',
      anchor_id: 'hero',
      title: 'Formación In Company para empresas',
      description:
        'Programas de formación a medida para desarrollar el talento de tu organización. Diseñados por TÜV SÜD Academy con expertos del sector.',
      cta_label: 'Solicitar información',
      form_title: 'Solicita información',
      form_cta_label: 'Enviar solicitud',
      hero_image: {
        filename: heroImage,
        alt: 'Corporate employee training session',
      },
    },
    {
      _uid: 'academy-es-certifications-strip',
      component: 'certifications_strip_section',
      items: [
        { icon: 'verified', label: '150+ años de experiencia' },
        { icon: 'workspace_premium', label: 'Certificación reconocida internacionalmente' },
        { icon: 'groups', label: '24.000+ empleados en todo el mundo' },
        { icon: 'school', label: 'Formadores expertos del sector' },
        { icon: 'shield', label: 'Confianza y seguridad garantizadas' },
      ],
    },
    {
      _uid: 'academy-es-benefits',
      component: 'corporate_benefits_section',
      anchor_id: 'ventajas',
      headline: 'Ventajas de la formación In Company',
      description:
        'La formación In Company permite capacitar a los equipos de forma eficiente mediante programas diseñados específicamente para los retos de cada organización.',
      benefits: [
        {
          icon: 'tune',
          title: 'Formación adaptada a la empresa',
          description:
            'Cada programa se diseña teniendo en cuenta el sector, los procesos y los retos específicos de la organización.',
        },
        {
          icon: 'schedule',
          title: 'Flexibilidad total',
          description:
            'La formación puede adaptarse a los horarios, el formato y el lugar que mejor se ajusten a la actividad de la empresa.',
        },
        {
          icon: 'savings',
          title: 'Optimización de recursos',
          description:
            'Permite formar a varios empleados al mismo tiempo reduciendo costes logísticos y de desplazamiento.',
        },
        {
          icon: 'engineering',
          title: 'Expertos del sector',
          description:
            'Nuestros formadores son profesionales con amplia experiencia técnica y conocimiento real de la industria.',
        },
        {
          icon: 'construction',
          title: 'Aplicación práctica',
          description: 'Los contenidos están orientados a resolver retos reales del entorno profesional.',
        },
        {
          icon: 'trending_up',
          title: 'Impacto medible',
          description:
            'Evaluamos y medimos los resultados de la formación para garantizar su impacto en el rendimiento de los equipos.',
        },
      ],
    },
    {
      _uid: 'academy-es-training-areas',
      component: 'training_areas_section',
      anchor_id: 'areas',
      headline: 'Áreas de formación',
      description:
        'TÜV SÜD Academy ofrece formación para empresas en diferentes áreas clave de la industria y los servicios.',
      areas: [
        {
          icon: 'health_and_safety',
          title: 'Seguridad Industrial',
          color: 'var(--ts-semantic-color-background-danger-subtle-default)',
          link_text: 'Más información',
        },
        {
          icon: 'shield',
          title: 'Seguridad y Salud en el Trabajo',
          color: 'var(--ts-semantic-color-background-success-subtle-default)',
          link_text: 'Más información',
        },
        {
          icon: 'description',
          title: 'Sistemas de Gestión (ISO)',
          color: 'var(--ts-semantic-color-background-primary-subtle-default)',
          link_text: 'Más información',
        },
        {
          icon: 'build',
          title: 'Mantenimiento y Organización Industrial',
          color: 'var(--ts-semantic-color-background-warning-subtle-default)',
          link_text: 'Más información',
        },
        {
          icon: 'search',
          title: 'Inspección y Control Técnico',
          color: 'var(--ts-semantic-color-background-neutral-subtle-default)',
          link_text: 'Más información',
        },
        {
          icon: 'eco',
          title: 'Energía y Sostenibilidad',
          color: 'var(--ts-semantic-color-background-success-subtle-default)',
          link_text: 'Más información',
        },
        {
          icon: 'precision_manufacturing',
          title: 'Manejo de maquinaria y equipos',
          color: 'var(--ts-semantic-color-background-danger-subtle-default)',
          link_text: 'Más información',
        },
        {
          icon: 'dashboard_customize',
          title: 'Programas 100% personalizados',
          color: 'var(--ts-semantic-color-background-primary-subtle-default)',
          link_text: 'Solicitar propuesta',
        },
      ],
    },
    {
      _uid: 'academy-es-process',
      component: 'process_steps_section',
      anchor_id: 'proceso',
      headline: 'Cómo diseñamos tu programa de formación',
      description:
        'Nuestro enfoque se basa en escuchar las necesidades del cliente y desarrollar soluciones formativas adaptadas a su organización.',
      steps: [
        {
          number: '01',
          title: 'Análisis de necesidades',
          description:
            'Un Key Account Manager y un consultor experto trabajan junto a los responsables de formación de la empresa para analizar los objetivos y necesidades formativas.',
          icon: 'analytics',
        },
        {
          number: '02',
          title: 'Diseño del programa formativo',
          description:
            'Definimos contenidos, metodología y formato para crear una solución adaptada a la organización.',
          icon: 'design_services',
        },
        {
          number: '03',
          title: 'Selección de expertos',
          description:
            'Las formaciones son impartidas por profesionales con experiencia en la industria y especialistas del ecosistema TÜV SÜD Academy.',
          icon: 'person_search',
        },
        {
          number: '04',
          title: 'Coordinación del proyecto',
          description:
            'Nos encargamos de toda la coordinación técnica y académica: planificación, equipo docente, materiales y plataformas de aprendizaje.',
          icon: 'task_alt',
        },
        {
          number: '05',
          title: 'Evaluación y mejora continua',
          description:
            'Realizamos seguimiento y evaluación continua para garantizar la calidad y el impacto de la formación.',
          icon: 'trending_up',
        },
      ],
    },
    {
      _uid: 'academy-es-methodology',
      component: 'methodology_section',
      anchor_id: 'metodologia',
      headline: 'Metodología: Learning by Doing',
      blocks: [
        {
          title: 'Enfoque práctico orientado a resultados',
          description:
            'Nuestros programas se basan en un enfoque práctico orientado a la aplicación real del conocimiento. Las sesiones formativas combinan:',
          image: {
            filename: methodologyWorkshopImage,
            alt: 'Workshop práctico',
          },
          bullets: [
            'Contenidos técnicos actualizados',
            'Casos reales del sector',
            'Ejercicios prácticos',
            'Resolución de retos del día a día profesional',
          ],
        },
        {
          title: 'Modalidades adaptadas a tu empresa',
          description:
            'Cursos In Company, programas de formación continua y soluciones formativas a medida alineadas con los objetivos estratégicos de la organización.',
          image: {
            filename: methodologyTeamImage,
            alt: 'Equipo en formación',
          },
          reverse: true,
        },
      ],
    },
    {
      _uid: 'academy-es-clients',
      component: 'client_names_section',
      anchor_id: 'clientes',
      headline: 'Empresas que confían en nosotros',
      description: 'Trabajamos con empresas líderes en diferentes sectores industriales y de servicios.',
      clients: [
        { name: 'Repsol', logo: { filename: logoRepsol, alt: 'Repsol' } },
        { name: 'Iberdrola', logo: { filename: logoIberdrola, alt: 'Iberdrola' } },
        { name: 'Cupra', logo: { filename: logoCupra, alt: 'Cupra' } },
        { name: 'Naturgy', logo: { filename: logoNaturgy, alt: 'Naturgy' } },
        { name: 'Acciona', logo: { filename: logoAcciona, alt: 'Acciona' } },
        { name: 'Gestamp', logo: { filename: logoGestamp, alt: 'Gestamp' } },
        { name: 'CaixaBank', logo: { filename: logoCaixaBank, alt: 'CaixaBank' } },
        { name: 'Airbus', logo: { filename: logoAirbus, alt: 'Airbus' } },
        { name: 'Siemens', logo: { filename: logoSiemens, alt: 'Siemens' } },
        { name: 'Endesa', logo: { filename: logoEndesa, alt: 'Endesa' } },
        { name: 'Ferrovial', logo: { filename: logoFerrovial, alt: 'Ferrovial' } },
        { name: 'Sacyr', logo: { filename: logoSacyr, alt: 'Sacyr' } },
      ],
    },
    {
      _uid: 'academy-es-faq',
      component: 'corporate_faq_section',
      anchor_id: 'faq',
      headline: 'Preguntas frecuentes',
      faqs: [
        {
          question: '¿Qué es la formación In Company?',
          answer:
            'La formación In Company son programas de capacitación diseñados a medida para una empresa específica. Se adaptan contenidos, formato, metodología y calendario a los objetivos de la organización.',
        },
        {
          question: '¿Dónde se imparten las formaciones?',
          answer:
            'Las formaciones pueden impartirse en las instalaciones de la empresa, en centros de formación de TÜV SÜD, o en modalidad online o blended learning.',
        },
        {
          question: '¿Quiénes son los formadores?',
          answer:
            'Nuestros formadores son profesionales con amplia experiencia técnica y conocimiento real de la industria, especialistas del ecosistema TÜV SÜD Academy.',
        },
        {
          question: '¿Cuánto tiempo dura un programa?',
          answer:
            'La duración varía según las necesidades: desde sesiones puntuales de un día hasta programas de formación continua de varios meses.',
        },
        {
          question: '¿Qué áreas temáticas cubren?',
          answer:
            'Cubrimos seguridad industrial, seguridad y salud laboral, sistemas de gestión ISO, mantenimiento industrial, inspección técnica, energía y sostenibilidad, y más.',
        },
        {
          question: '¿Cómo se diseña un programa a medida?',
          answer:
            'Comenzamos con un análisis de necesidades junto a la empresa, diseñamos el programa, seleccionamos expertos, coordinamos toda la logística y realizamos evaluación continua.',
        },
        {
          question: '¿Puedo obtener certificaciones reconocidas?',
          answer:
            'Sí. Al ser TÜV SÜD una entidad de certificación reconocida internacionalmente, muchos de nuestros programas incluyen certificaciones con validez internacional.',
        },
        {
          question: '¿Cuál es el número mínimo de participantes?',
          answer:
            'No existe un mínimo estricto. Adaptamos cada programa a las necesidades de la empresa, tanto para grupos pequeños como para formaciones a gran escala.',
        },
      ],
    },
    {
      _uid: 'academy-es-conversion-cta',
      component: 'corporate_conversion_cta_section',
      headline: 'Impulsa el talento de tu equipo',
      description:
        'Contacta con TÜV SÜD Academy y recibe una propuesta personalizada de formación para tu organización.',
      cta_label: 'Solicitar información',
    },
    {
      _uid: 'academy-es-contact',
      component: 'corporate_contact_form_section',
      anchor_id: 'contacto',
      headline: 'Solicita una propuesta de formación',
      description:
        'Si tu empresa necesita formación In Company o soluciones formativas a medida, nuestro equipo te ayudará a diseñar el programa más adecuado.',
      submit_label: 'Enviar solicitud',
      options: [
        { value: 'seguridad', label: 'Seguridad Industrial' },
        { value: 'sst', label: 'Seguridad y Salud en el Trabajo' },
        { value: 'iso', label: 'Sistemas de Gestión (ISO)' },
        { value: 'mantenimiento', label: 'Mantenimiento Industrial' },
        { value: 'inspeccion', label: 'Inspección y Control Técnico' },
        { value: 'energia', label: 'Energía y Sostenibilidad' },
        { value: 'otro', label: 'Otro' },
      ],
      contact_items: [
        { icon: 'email', label: 'Email', value: 'academy.es@tuvsud.com' },
        { icon: 'phone', label: 'Teléfono', value: '+34 934 804 927' },
        { icon: 'location_on', label: 'Dirección', value: 'Barcelona, España' },
      ],
      reasons: [
        'Entidad de certificación reconocida internacionalmente',
        'Más de 150 años de experiencia',
        'Formadores con experiencia real en la industria',
        'Metodología Learning by Doing',
        'Programas 100% personalizables',
      ],
    },
    {
      _uid: 'academy-es-footer',
      component: 'corporate_footer_section',
      brand_label: 'TÜV SÜD Academy España',
      links: [
        { label: 'Términos y Condiciones', href: 'https://www.tuvsud.com/es-es/terminos-condiciones' },
        { label: 'Aviso legal', href: 'https://www.tuvsud.com/es-es/aviso-legal' },
        { label: 'Política de Privacidad', href: 'https://www.tuvsud.com/es-es/politica-privacidad' },
      ],
    },
  ],
} satisfies StaticLandingPage;
